import * as React from 'react';
import ModalContext from '../ModalContext';
export const DrawerTarget = ({ id, children }) => {
    return (React.createElement(ModalContext.Consumer, null, ({ modals, hideTarget }) => {
        const { modalId, isOpen } = modals.find(({ modalId }) => modalId === id) || {};
        // For drawers, the child should always render.
        // Drawers implement their own hide/show behaviour that relies
        // on `isOpen` being toggled to trigger the animation
        return children({ hideTarget, isOpen: isOpen && modalId === id });
    }));
};
//# sourceMappingURL=DrawerTarget.js.map